import { render, staticRenderFns } from "./LowerPart.vue?vue&type=template&id=dca1ebe6&scoped=true&"
import script from "./LowerPart.vue?vue&type=script&lang=js&"
export * from "./LowerPart.vue?vue&type=script&lang=js&"
import style0 from "./LowerPart.vue?vue&type=style&index=0&id=dca1ebe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca1ebe6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
